import { AppWrapper } from 'components/AppWrapper';
import { SurveyList } from 'components/SurveyList';

import { SidePoints } from './SidePoints';

export default function Home() {
  return (
    <AppWrapper leftContent={<SidePoints />}>
      <SurveyList />
    </AppWrapper>
  );
}
